import { useState } from "react";

import { getPokerServiceLocationBase } from '../../../common/api/data';
import { ModalChoosePlayerName } from './modalchooseplayername';

export const PlayerIdsTable = ({ title, list, players, reloadApplication }) => {
	
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [playerId, setPlayerId] = useState(undefined);

	const assign = (id) => {
		//alert('You are attempting to pick: ' + pickParam);
		setPlayerId(id);
		setModalIsOpen(true);
	};

	const handleModalNo = () => {
		setModalIsOpen(false);
	};

	const handleModalYes = (pickedPlayerName) => {
		setModalIsOpen(false);
		//let pickedPlayerName = 'abc'
		//alert('Save the pick: ' + pickedTeam);
		if (pickedPlayerName !== undefined) {
			sendAssignment(playerId, pickedPlayerName);
		}
	};

	const sendAssignment = (id, name) => {
		//alert('id=' + id);
		//alert('name=' + name);
		fetch(getPokerServiceLocationBase() + '/assign?id=' + id + '&name=' + name)
		.then(res => res.text())
		.then(text => {
			console.log(text);
			reloadApplication();
		})
		.catch(console.log);
		/*fetch(getThreeStrikesServiceLocationBase() + '/pick' + '?email=' + email + '&favorite=' + password + '&pick=' + pick)
		.then(res => res.text())
		.then(text => {
			alert(text);
		})
		.catch(console.log)*/
	};

	if (list === undefined) {
		return (
			<div>
				<h3>{title}</h3>
				Loading...
			</div>
		);
	} else {
		/*
		idsWithoutNames: Array(6) [ {…}, {…}, {…}, … ]
			0: Object { playerId: "Xi3Ognm5lT", playerNickname: "Queue138" }
			1: Object { playerId: "Aj3QBYnK2t", playerNickname: "Queue136" }
			2: Object { playerId: "Aj3QBYnK2t", playerNickname: "Queue135" }
			3: Object { playerId: "Aj3QBYnK2t", playerNickname: "Queue134" }
			4: Object { playerId: "Aj3QBYnK2t", playerNickname: "Queue133" }
			5: Object { playerId: "Aj3QBYnK2t", playerNickname: "Queue132" }
		*/
		//console.log(players[0]['personRealname'])
		const groupedPlayers = Map.groupBy(list, p => {
			return p.playerId;
		});
		//console.log(groupedPlayers)
		var keys = [];
		let i = 0;
		for (const [key] of groupedPlayers) {
			keys[i] = key;
			//console.log('key: ' + key)
			//console.log('val: ' + groupedPlayers.get(key)[0]['playerNickname'] )
			i ++;
		}
		
		//console.log(groupedPlayers.keys() )
		var j = 0;
		return (
			<div>
				<ModalChoosePlayerName 
					ynmOpen={modalIsOpen} 
					ynmQuestionText={'You are about to assign id: ' + playerId} 
					ynmNoText='Cancel' 
					ynmYesText='Submit Assignment' 
					ynmNoFunction={handleModalNo} 
					ynmYesFunction={handleModalYes} 
					list={players}
				/>
				<h3>{title}</h3>
				<table className={"idsTable"}>
					<thead bgcolor='#22ccee'>
						<tr>
							<th>Player Id</th>
							<th>Nickname(s)</th>
							<th>Action</th>
						</tr>
					</thead>
				{keys.map( (r) => (
					<tbody key={r} >
						<tr>
							<td>{r}</td>
							<td>
							{groupedPlayers.get(r).map( (p) => (
								<div key={j ++} >{p['playerNickname']}</div>
							))}
							</td>
							<td><button onClick={() => assign(r)}>Assign Player</button></td>
						</tr>
					</tbody>
				))}
				</table>
			</div>
		);
	}
};
